import { useSnackbar } from "../../../utils/notificacoes"
import { createContext, useContext, useEffect, useMemo, useRef, useState } from "react"
import { useParams } from "react-router-dom/cjs/react-router-dom"
import {
    cadastrarCategoria,
    cadastrarGrupoDeOpcao,
    cadastrarImagem,
    cadastrarOpcao,
    cadastrarProduto,
    duplicarCategoria,
    duplicarGrupoDeOpcao,
    duplicarProduto,
    excluirCategoria,
    excluirGrupoDeOpcao,
    excluirOpcao,
    excluirProduto,
    obterCardapioParaEdicaoEmMassa,
    salvarCardapioCompleto,
} from "../../../services/cardapio"
import { ObterCardapioNovo } from "../../../services/clientefiel"
import {
    atualizarFichaTecnica,
    buscarFichaTecnicaOpcao,
    buscarFichaTecnicaProduto,
    buscarFihcasTecnicas,
    salvarFichaTecnica,
} from "../../../services/fichaTecnica"
import { buscarInsumos } from "../../../services/insumos"
import useLoadingStore from "../../../stores/LoadingStore"

// Produto especial que guarda os "passos comuns" da categoria: o backend replica
// os passos de montagem dele em TODOS os produtos da categoria. Fica em primeira
// posição (ordemExib = -99999) e é gerenciado pelo botão "Passos comuns".
export const ORDEM_ADICIONAIS = -99999
export const ehProdutoAdicionais = p =>
    p?.nome === "Adicionais" && Number(p?.ordemExib) === ORDEM_ADICIONAIS

const CardapioContext = createContext(null)

export const useCardapioContext = () => {
    const context = useContext(CardapioContext)
    if (!context) throw new Error("useCardapioContext deve ser usado dentro de CardapioProvider")
    return context
}

export const Sincronizacao99Context = createContext()

let idsSave = []
let mudarCategoria = false

export const CardapioProvider = ({ children, estabelecimento }) => {
    const autorizacao = localStorage.getItem("chaveSistema")
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => enqueueSnackbar(msg, { variant: tipo })

    const { tela } = useParams()

    const [cadastrar, setCadastrar] = useState(true)
    const [cardapio, setCardapio] = useState()
    const [categorias, setCategorias] = useState()
    const [items, setItems] = useState()
    const [insumos, setInsumos] = useState([])
    const [FTEstabelecimento, setFTEstabelecimento] = useState()
    const [salvarCardapio, setSalvarCardapioCompleto] = useState(false)
    const [renderKey, setRenderKey] = useState(0)
    const forcarRenderizacao = () => setRenderKey(k => k + 1)

    const [sincronizar99Handler, setSincronizar99Handler] = useState()

    const [categoriaAtual, setCategoriaAtual] = useState("")
    const [produtoAtual, setProdutoAtual] = useState("")
    const [openCategoria, setOpenCategoria] = useState(false)
    const [openProduto, setOpenproduto] = useState(false)
    const [openPassoDeMontagem, setOpenPassoDeMontagem] = useState(false)
    const [modalCategoria, setModalCategoria] = useState(null)
    const [modalProduto, setModalProduto] = useState(null)
    const [modalPasso, setModalPasso] = useState(null)
    const [idPasso, setIdPasso] = useState(null)
    const [openDuplicarGrupoDeMontagem, setOpenDuplicarGrupoDeMontagem] = useState(false)

    const [insumoSelecionado, setInsumoSelecionado] = useState(null)
    const [insumosSelecionados, setInsumosSelecionados] = useState([])
    const [fichaTecnica, setFichaTecnica] = useState(null)
    const [quantidades, setQuantidades] = useState({})
    const [altInsumo, setAltInsumo] = useState(false)
    const [produto, setProduto] = useState(false)
    const idsEditados = useRef(new Set())
    // Espelho reativo de idsSave/idsEditados: indica que há edições inline (preço/ordem)
    // ainda não persistidas pelo "Salvar" global. Usado para avisar antes de sair.
    const [temAlteracoesPendentes, setTemAlteracoesPendentes] = useState(false)

    useEffect(() => {
        const buscarCardapioProduto = async () => {
            setLoading(true)
            try {
                const response = await ObterCardapioNovo(autorizacao, {
                    idEstabelecimento: estabelecimento?.id,
                    token: "a~I?;;+_@!AL^",
                })
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                } else {
                    setCardapio(response)
                    setCategorias(response.categorias)
                }
            } catch {
            } finally {
                setLoading(false)
            }
        }

        const buscarCardapioMassa = async () => {
            setLoading(true)
            try {
                const response = await obterCardapioParaEdicaoEmMassa(
                    estabelecimento?.id,
                    autorizacao
                )
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                    return false
                } else {
                    setItems(response)
                }
            } catch {
            } finally {
                setLoading(false)
            }
        }

        const buscarInusmos = async () => {
            setLoading(true)
            try {
                const response = await buscarInsumos(estabelecimento?.id, autorizacao)
                if (response.retornoErro === 1) {
                    return setInsumos([])
                }
                setInsumos(response)
                buscarCardapioProduto()
            } catch {
            } finally {
                setLoading(false)
            }
        }

        const buscarFichaTecnica = async () => {
            setLoading(true)
            try {
                const response = await buscarFihcasTecnicas(estabelecimento?.id, autorizacao)
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                    return false
                } else {
                    setFTEstabelecimento(response)
                    buscarInusmos()
                    buscarCardapioProduto()
                }
            } catch {
            } finally {
                setLoading(false)
            }
        }

        if (tela === "produtos") {
            buscarCardapioProduto()
        } else if (tela === "massa") {
            buscarCardapioMassa()
        } else if (tela === "insumos") {
            buscarInusmos()
        } else if (tela === "ficha-tecnica") {
            buscarFichaTecnica()
        }
    }, [tela])

    // Re-busca o cardapio pela MESMA fonte do carregamento/F5 (ObterCardapioNovo),
    // garantindo o mesmo formato de dados. Usado apos aplicar alteracoes da IA,
    // que retornam um CardapioView (formato diferente) e nao renderizam igual.
    const recarregarCardapio = async () => {
        setLoading(true)
        try {
            const response = await ObterCardapioNovo(autorizacao, {
                idEstabelecimento: estabelecimento?.id,
                token: "a~I?;;+_@!AL^",
            })
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setCardapio(response)
                setCategorias(response.categorias)
            }
        } catch (error) {
            console.error("Erro ao recarregar Cardápio", error)
        } finally {
            setLoading(false)
        }
    }

    // Garante que exista o produto "Adicionais" (passos comuns) na categoria e o retorna.
    const garantirProdutoAdicionais = async idCategoria => {
        const cat = categorias?.find(c => c.id === idCategoria)
        if (!cat) return null
        const existente = cat.produtos?.find(ehProdutoAdicionais)
        if (existente) return existente

        setLoading(true)
        try {
            const data = {
                nome: "Adicionais",
                ordemExib: ORDEM_ADICIONAIS,
                valor: 0,
                ativo: true,
                descricao: "",
                // Obrigatório: o cadastro de produto no back faz modelMapper.map da
                // disponibilidadeProduto e quebra ("source cannot be null") se vier null.
                disponibilidadeProduto: {},
                token: "a~I?;;+_@!AL^",
            }
            const response = await cadastrarProduto(idCategoria, data, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return null
            }
            const novo = { ...response, opcoes: response.opcoes || [] }
            setCategorias(prev =>
                prev.map(c =>
                    c.id === idCategoria
                        ? { ...c, produtos: [...(c.produtos || []), novo] }
                        : c
                )
            )
            return novo
        } catch (error) {
            console.error("Erro ao garantir produto Adicionais", error)
            return null
        } finally {
            setLoading(false)
        }
    }

    const handleSalvarCategoria = async data => {
        setLoading(true)
        const response = await cadastrarCategoria(cardapio?.id, data, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            if (cadastrar) {
                setCategorias(prev => [...prev, response])
                alertStart("Categoria cadastrada com sucesso", "success")
            } else {
                setCategorias(prev => prev.map(cat => (cat.id === data.id ? response : cat)))
                alertStart("Categoria editada com sucesso", "success")
            }
        }
        setLoading(false)
    }

    // Persiste alterações no NÍVEL de categoria (ordem/nome) salvando o cardápio
    // inteiro — mesmo caminho do DialogReordenar. É necessário porque o "Salvar
    // Alterações" (handleSalvarCardapioInteiro) só envia categorias que têm produto
    // editado, então ordem/nome de categoria não seriam persistidos por ali.
    const persistirCategorias = async novasCategorias => {
        setLoading(true)
        try {
            const data = { ...cardapio, categorias: novasCategorias }
            const response = await salvarCardapioCompleto(estabelecimento.id, data, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            setCategorias(novasCategorias)
            return true
        } catch (error) {
            console.error(error)
            alertStart("Erro ao salvar as categorias", "error")
            return false
        } finally {
            setLoading(false)
        }
    }

    const handleDuplicarCategoria = async idCategoria => {
        setLoading(true)
        const response = await duplicarCategoria({ id: idCategoria }, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            setCategorias(prev => {
                categorias.push(response)
                return [...prev]
            })
            alertStart("Categoria duplicada com sucesso", "success")
        }
        setLoading(false)
    }

    const handleExcluirCategoria = async idCategoria => {
        setLoading(true)
        const response = await excluirCategoria({ id: idCategoria }, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            setCategorias(prev => prev.filter(item => item.id !== idCategoria))
            alertStart("Categoria excluída com sucesso", "success")
        }
        setLoading(false)
    }

    const handleSalvarProduto = async (idCategoria, data) => {
        setLoading(true)
        const categoriaProduto = categorias.findIndex(c => c.id === idCategoria)
        if (categorias[categoriaProduto]?.produtos.findIndex(c => c.id === data.id) === -1) {
            mudarCategoria = true
        }
        const response = await cadastrarProduto(idCategoria, data, autorizacao)
        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            return false
        } else {
            if (cadastrar) {
                if (categoriaProduto === -1) return categorias
                setCategorias(prev =>
                    prev.map(cat =>
                        cat.id === idCategoria
                            ? { ...cat, produtos: [...cat.produtos, response] }
                            : cat
                    )
                )
                alertStart("Produto cadastrado com sucesso", "success")
            } else if (mudarCategoria) {
                setCategorias(prev =>
                    prev?.map(cat => {
                        if (cat.produtos.some(produto => produto.id === data.id)) {
                            return {
                                ...cat,
                                produtos: cat.produtos.filter(produto => produto.id !== data.id),
                            }
                        } else if (cat.id === idCategoria) {
                            return { ...cat, produtos: [...cat.produtos, response] }
                        }
                        return cat
                    })
                )
                alertStart("Produto editado com sucesso", "success")
            } else {
                // Atualiza o produto no estado (imutável) em vez de escrever direto no DOM.
                // A linha inline reflete os novos valores via `key` por versão (Categorias.js).
                setCategorias(prev =>
                    prev?.map(cat =>
                        cat.id === idCategoria
                            ? {
                                  ...cat,
                                  produtos: cat.produtos.map(p =>
                                      p.id === response.id ? { ...p, ...response } : p
                                  ),
                              }
                            : cat
                    )
                )
                alertStart("Produto editado com sucesso", "success")
            }
        }
        mudarCategoria = false
        setLoading(false)
        return true
    }

    const handleDuplicarProduto = async (idProduto, idCategoria) => {
        setLoading(true)
        const categoriaProduto = categorias.findIndex(c => c.id === idCategoria)
        if (categorias[categoriaProduto]?.produtos?.findIndex(c => c.id === idProduto) === -1) {
            mudarCategoria = true
        }
        const response = await duplicarProduto({ id: idProduto }, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            if (categoriaProduto === -1) return categorias
            delete response.md5Imagem
            delete response.impressaoEmSeparado
            delete response.tipo
            delete response.idCategoria
            delete response.categoriaTemp
            setCategorias(prev => {
                const updated = [...prev]
                updated[categoriaProduto] = {
                    ...updated[categoriaProduto],
                    produtos: [...(updated[categoriaProduto]?.produtos || []), response],
                }
                return updated
            })
            alertStart("Produto duplicado com sucesso", "success")
        }
        setLoading(false)
    }

    const handleExcluirProduto = async (idProduto, idCategoria) => {
        setLoading(true)
        const categoriaProduto = categorias.findIndex(c => c.id === idCategoria)
        if (categoriaProduto === -1) {
            console.warn("Produto não encontrado ")
            return
        }
        const produtoIndex = categorias[categoriaProduto]?.produtos?.findIndex(
            p => p.id === idProduto
        )
        if (produtoIndex === -1) {
            console.warn("Produto não encontrado ")
            return
        }
        const response = await excluirProduto({ id: idProduto }, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            setCategorias(prev => {
                const updated = [...prev]
                updated[categoriaProduto].produtos = updated[categoriaProduto].produtos.filter(
                    p => p.id !== idProduto
                )
                return updated
            })
            alertStart("Produto excluído com sucesso", "success")
        }
        setLoading(false)
    }

    const handleCadastrarGrupoDeOpcao = async (idProduto, data) => {
        setLoading(true)
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }
        const catId = categorias[categoriaIndex].id
        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }
        const response = await cadastrarGrupoDeOpcao(idProduto, data, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            if (cadastrar) {
                setCategorias(prev =>
                    prev.map(cat =>
                        cat.id === catId
                            ? {
                                  ...cat,
                                  produtos: cat.produtos.map(prod =>
                                      prod.id === idProduto
                                          ? { ...prod, opcoes: [...prod.opcoes, response] }
                                          : prod
                                  ),
                              }
                            : cat
                    )
                )
                alertStart("Passo de montagem cadastrado com sucesso", "success")
            } else {
                setCategorias(prev =>
                    prev.map(cat =>
                        cat.id === catId
                            ? {
                                  ...cat,
                                  produtos: cat.produtos.map(prod =>
                                      prod.id === idProduto
                                          ? {
                                                ...prod,
                                                opcoes: prod.opcoes.map(opcao =>
                                                    opcao.id === data.id ? response : opcao
                                                ),
                                            }
                                          : prod
                                  ),
                              }
                            : cat
                    )
                )
                alertStart("Passo de montagem editado com sucesso", "success")
            }
        }
        setLoading(false)
    }

    const handleDuplicarPassoDeMontagem = async (idProduto, idPasso) => {
        setLoading(true)
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }
        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }
        const response = await duplicarGrupoDeOpcao({ id: idPasso }, idProduto, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            setCategorias(prev => {
                const updated = [...prev]
                updated[categoriaIndex].produtos[produtoIndex].opcoes.push(response)
                return updated
            })
            alertStart("Passo de montagem duplicado com sucesso", "success")
        }
        setLoading(false)
    }

    const handleExcluirGrupoDeOpcao = async (idProduto, idGrupoOpcao) => {
        setLoading(true)
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }
        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }
        const response = await excluirGrupoDeOpcao({ id: idGrupoOpcao }, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            setCategorias(prev => {
                const updated = [...prev]
                updated[categoriaIndex].produtos[produtoIndex].opcoes = updated[
                    categoriaIndex
                ].produtos[produtoIndex].opcoes.filter(o => o.id !== idGrupoOpcao)
                return updated
            })
            alertStart("Passo de montagem excluído com sucesso", "success")
        }
        setLoading(false)
    }

    const handleCadastrarOpcao = async (idProduto, idPasso) => {
        setLoading(true)
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }
        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }
        const passoIndex = categorias[categoriaIndex].produtos[produtoIndex].opcoes.findIndex(
            passo => passo.id === idPasso
        )
        if (passoIndex === -1) {
            console.error("passo não encontrado.")
            return
        }
        const opcoesExistentes =
            categorias[categoriaIndex].produtos[produtoIndex].opcoes[passoIndex].opcoes ?? []
        const proximaOrdemExib =
            Math.max(0, ...opcoesExistentes.map(o => Number(o.ordemExib) || 0)) + 1

        const data = {
            nome: "Nova opção",
            valor: "",
            codigo: "",
            descricao: "",
            ativo: true,
            ordemExib: proximaOrdemExib,
            informativo: false,
            tipoProducao: null,
            impressaoAlternada: 0,
        }
        const response = await cadastrarOpcao(idPasso, data, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            setCategorias(prev =>
                prev.map((cat, ci) =>
                    ci !== categoriaIndex
                        ? cat
                        : {
                              ...cat,
                              produtos: cat.produtos.map((prod, pi) =>
                                  pi !== produtoIndex
                                      ? prod
                                      : {
                                            ...prod,
                                            opcoes: prod.opcoes.map((passo, si) =>
                                                si !== passoIndex
                                                    ? passo
                                                    : {
                                                          ...passo,
                                                          opcoes: [...passo.opcoes, response],
                                                      }
                                            ),
                                        }
                              ),
                          }
                )
            )
            alertStart("Opção cadastrada com sucesso", "success")
        }
        setLoading(false)
    }

    const handleExcluirOpcao = async (idProduto, idPasso, idOpcao, index) => {
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }
        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }
        const passoIndex = categorias[categoriaIndex].produtos[produtoIndex].opcoes.findIndex(
            passo => passo.id === idPasso
        )
        if (passoIndex === -1) {
            console.error("Passo não encontrado.")
            return
        }
        if (!idOpcao) {
            setCategorias(prev => {
                const updated = [...prev]
                updated[categoriaIndex].produtos[produtoIndex].opcoes[passoIndex].opcoes.splice(
                    index,
                    1
                )
                return updated
            })
            return
        }
        setLoading(true)
        const response = await excluirOpcao({ id: idOpcao }, autorizacao)
        if (response.retornoErro) {
            alertStart(response.mensagem, "error")
        } else {
            setCategorias(prev => {
                const updated = [...prev]
                updated[categoriaIndex].produtos[produtoIndex].opcoes[passoIndex].opcoes = updated[
                    categoriaIndex
                ].produtos[produtoIndex].opcoes[passoIndex].opcoes.filter(o => o.id !== idOpcao)
                return updated
            })
            alertStart("Opção de montagem excluída com sucesso", "success")
        }
        setLoading(false)
    }

    const handleIdsEditar = idProduto => {
        idsEditados.current.add(idProduto)
        idsSave = Array.from(idsEditados.current)
        setTemAlteracoesPendentes(true)
    }

    const handleSalvarCardapioInteiro = async () => {
        if (!(idsSave.length >= 1 || salvarCardapio)) {
            alertStart("Nenhuma alteração pendente para salvar", "info")
            return
        }
        if (idsSave.length >= 1 || salvarCardapio) {
            setLoading(true)
            let data = null
            if (salvarCardapio) {
                data = cardapio
            } else {
                data = {
                    ...cardapio,
                    categorias: categorias
                        .map(categoria => {
                            const produtosFiltrados = categoria.produtos.filter(produto =>
                                idsSave.includes(produto.id)
                            )
                            if (produtosFiltrados.length > 0) {
                                return { ...categoria, produtos: produtosFiltrados }
                            }
                            return null
                        })
                        .filter(categoria => categoria !== null),
                }
            }
            const response = await salvarCardapioCompleto(estabelecimento.id, data, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                alertStart("Cardapio salvo com sucesso", "success")
            }
            idsEditados.current.clear()
            idsSave = []
            setTemAlteracoesPendentes(false)
            setSalvarCardapioCompleto(false)
            setLoading(false)
        }
    }

    const handleCadastrarImagem = async (
        nomeArquivo,
        idProduto,
        idPasso,
        idOpcao,
        file,
        edicaoMassa
    ) => {
        if (idProduto === null && idPasso === null && idOpcao === null) {
            setLoading(true)
            try {
                const response = await cadastrarImagem(
                    estabelecimento.id,
                    nomeArquivo,
                    idProduto,
                    idOpcao,
                    file,
                    autorizacao
                )
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                } else {
                    return response.valor
                }
            } catch (error) {
                console.error(error)
            } finally {
                setLoading(false)
            }
        }
        const categoriaIndex =
            typeof idProduto === "string"
                ? categorias.findIndex(categoria =>
                      categoria.produtos.some(produto => produto.nome === idProduto)
                  )
                : categorias.findIndex(categoria =>
                      categoria.produtos.some(produto => produto.id === idProduto)
                  )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }
        const produtoIndex =
            typeof idProduto === "string"
                ? categorias[categoriaIndex].produtos.findIndex(
                      produto => produto.nome === idProduto
                  )
                : categorias[categoriaIndex].produtos.findIndex(produto => produto.id === idProduto)
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }
        const passoIndex = idPasso
            ? categorias[categoriaIndex].produtos[produtoIndex].opcoes.findIndex(
                  passo => passo.id === idPasso
              )
            : null
        if (passoIndex === -1) {
            console.error("Passo não encontrado.")
            return
        }
        const opcaoIndex = idOpcao
            ? categorias[categoriaIndex]?.produtos[produtoIndex]?.opcoes[
                  passoIndex
              ]?.opcoes.findIndex(opcao => opcao.id === idOpcao)
            : null
        if (opcaoIndex === -1) {
            console.error("Passo não encontrado.")
            return
        }
        try {
            setLoading(true)
            const response = await cadastrarImagem(
                estabelecimento.id,
                nomeArquivo,
                idProduto,
                idOpcao,
                file,
                autorizacao
            )
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                if (idOpcao) {
                    if (edicaoMassa) {
                        return response.valor
                    } else {
                        setCategorias(prev => {
                            prev[categoriaIndex].produtos[produtoIndex].opcoes[passoIndex].opcoes[
                                opcaoIndex
                            ].urlImagem = response.valor
                            return [...prev]
                        })
                    }
                } else {
                    if (edicaoMassa) {
                        return response.valor
                    } else {
                        setCategorias(prev => {
                            prev[categoriaIndex].produtos[produtoIndex].urlImagem = response.valor
                            return [...prev]
                        })
                    }
                }
                alertStart("Imagem atualizada com sucesso", "success")
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const buscarFT = async (tipo, idProduto, idOpcao) => {
        try {
            setLoading(true)
            if (tipo === "produto") {
                const response = await buscarFichaTecnicaProduto(
                    estabelecimento.id,
                    idProduto,
                    autorizacao
                )
                if (response.retornoErro === 1) {
                    setFichaTecnica(null)
                } else {
                    setFichaTecnica(response)
                    setProduto(true)
                }
                const quantidadesIniciais = {}
                response?.insumos?.forEach(insumo => {
                    quantidadesIniciais[insumo.id] = insumo.quantidade ?? null
                })
                setQuantidades(quantidadesIniciais)
            } else if (tipo === "opcao") {
                const response = await buscarFichaTecnicaOpcao(
                    estabelecimento.id,
                    idOpcao,
                    autorizacao
                )
                if (response.retornoErro === 1) {
                    setFichaTecnica(null)
                    setProduto(false)
                } else {
                    setFichaTecnica(response)
                }
                const quantidadesIniciais = {}
                response?.insumos?.forEach(insumo => {
                    quantidadesIniciais[insumo.id] = insumo.quantidade ?? null
                })
                setQuantidades(quantidadesIniciais)
            }
        } catch (error) {
            alertStart("Erro ao buscar ficha técnica", "error")
        } finally {
            setLoading(false)
        }
    }

    const handleAddInsumo = () => {
        setAltInsumo(true)
        if (!insumoSelecionado) return
        if (fichaTecnica) {
            const exists = fichaTecnica.insumos?.some(i => i.id === insumoSelecionado.id)
            if (!exists) {
                setFichaTecnica(prev => ({
                    ...prev,
                    insumos: [...prev.insumos, insumoSelecionado],
                }))
                setQuantidades(prev => ({ ...prev, [insumoSelecionado.id]: null }))
            }
        } else {
            const exists = insumosSelecionados.some(i => i.id === insumoSelecionado.id)
            if (!exists) {
                setInsumosSelecionados(prev => [...prev, insumoSelecionado])
                setQuantidades(prev => ({ ...prev, [insumoSelecionado.id]: null }))
            }
        }
        setInsumoSelecionado(null)
    }

    const handleDeleteInsumo = idInsumo => {
        setAltInsumo(true)
        if (fichaTecnica) {
            setFichaTecnica(prev => ({
                ...prev,
                insumos: prev?.insumos?.filter(i => i.id !== idInsumo),
            }))
        } else {
            setInsumosSelecionados(prev => prev?.filter(i => i.id !== idInsumo))
        }
        setQuantidades(prev => {
            const nova = { ...prev }
            delete nova[idInsumo]
            return nova
        })
    }

    const montarDataFichaTecnica = (idProduto, idOpcao) => {
        const insumosFinal = (fichaTecnica ? fichaTecnica?.insumos : insumosSelecionados).map(
            insumo => ({
                id: insumo.id,
                quantidade: quantidades[insumo.id]?.toString() ?? null,
            })
        )
        const data = { insumos: insumosFinal }
        if (idProduto) {
            data.produtoId = idProduto
        } else if (idOpcao) {
            data.opcaoId = idOpcao
        }
        return data
    }

    const salvarFt = async (idProduto, idOpcao) => {
        if (!altInsumo) return
        try {
            setLoading(true)
            if (fichaTecnica) {
                const response = await atualizarFichaTecnica(
                    estabelecimento.id,
                    fichaTecnica?.id,
                    montarDataFichaTecnica(idProduto, idOpcao),
                    autorizacao
                )
                if (response.retornoErro === 1) {
                    alertStart(response.mensagem, "error")
                } else {
                    alertStart("Ficha técnica atualizada com sucesso", "success")
                }
            } else {
                const response = await salvarFichaTecnica(
                    estabelecimento.id,
                    montarDataFichaTecnica(idProduto, idOpcao),
                    autorizacao
                )
                if (response.retornoErro === 1) {
                    alertStart(response.mensagem, "error")
                } else {
                    alertStart("Ficha técnica cadastrada com sucesso", "success")
                }
            }
        } catch (error) {
            alertStart("Erro: " + error, "error")
        } finally {
            setInsumosSelecionados([])
            setLoading(false)
        }
    }

    const handleToggleDuplicarGrupoDeMontagem = data => {
        setIdPasso(data)
        setOpenDuplicarGrupoDeMontagem(prev => !prev)
    }

    const value = useMemo(
        () => ({
            estabelecimento,

            cardapio,
            setCardapio,
            categorias,
            setCategorias,
            renderKey,
            forcarRenderizacao,
            recarregarCardapio,
            garantirProdutoAdicionais,
            items,
            setItems,
            insumos,
            setInsumos,
            FTEstabelecimento,
            setFTEstabelecimento,
            cadastrar,
            setCadastrar,
            setSalvarCardapioCompleto,

            sincronizar99Handler,
            setSincronizar99Handler,

            categoriaAtual,
            setCategoriaAtual,
            produtoAtual,
            setProdutoAtual,
            openCategoria,
            setOpenCategoria,
            openProduto,
            setOpenproduto,
            openPassoDeMontagem,
            setOpenPassoDeMontagem,
            modalCategoria,
            setModalCategoria,
            modalProduto,
            setModalProduto,
            modalPasso,
            setModalPasso,
            idPasso,
            openDuplicarGrupoDeMontagem,
            handleToggleDuplicarGrupoDeMontagem,

            insumoSelecionado,
            setInsumoSelecionado,
            insumosSelecionados,
            fichaTecnica,
            quantidades,
            setQuantidades,
            altInsumo,
            setAltInsumo,
            produto,

            handleSalvarCategoria,
            persistirCategorias,
            handleDuplicarCategoria,
            handleExcluirCategoria,

            handleSalvarProduto,
            handleDuplicarProduto,
            handleExcluirProduto,

            handleCadastrarGrupoDeOpcao,
            handleDuplicarPassoDeMontagem,
            handleExcluirGrupoDeOpcao,

            handleCadastrarOpcao,
            handleExcluirOpcao,

            handleIdsEditar,
            handleSalvarCardapioInteiro,
            temAlteracoesPendentes,
            handleCadastrarImagem,

            buscarFT,
            handleAddInsumo,
            handleDeleteInsumo,
            salvarFt,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            estabelecimento,
            cardapio,
            categorias,
            items,
            insumos,
            FTEstabelecimento,
            cadastrar,
            sincronizar99Handler,
            categoriaAtual,
            produtoAtual,
            openCategoria,
            openProduto,
            openPassoDeMontagem,
            modalCategoria,
            modalProduto,
            modalPasso,
            idPasso,
            openDuplicarGrupoDeMontagem,
            insumoSelecionado,
            insumosSelecionados,
            fichaTecnica,
            quantidades,
            altInsumo,
            produto,
            salvarCardapio,
            renderKey,
            temAlteracoesPendentes,
        ]
    )

    return (
        <Sincronizacao99Context.Provider value={{ sincronizar99Handler, setSincronizar99Handler }}>
            <CardapioContext.Provider value={value}>{children}</CardapioContext.Provider>
        </Sincronizacao99Context.Provider>
    )
}
